export default __webpack_public_path__ + "static/BoschSans-Regular-415c0a854eec38f2c3562828dd93c4f8.woff2";